document.addEventListener("DOMContentLoaded", function () {
const drawer = document.getElementById("lumina-thym--filters-drawer");
const openButton = document.getElementById("lumina-thym--filters-drawer-open");
const closeButton = document.getElementById("lumina-thym--filters-drawer-close");
const headerBar = document.querySelector(".announcement-bar-static");
const header = document.querySelector(".shopify-section-header");
const overlay = document.querySelector(".drawer-overlay");

if (!drawer || !openButton || !closeButton) return;

// Function to open drawer
function openDrawer() {
drawer.classList.add("open");
if (headerBar) headerBar.style.zIndex = "0";
if (header) header.style.zIndex = "0";
if (overlay) overlay.classList.add("active");
}

// Function to close drawer
function closeDrawer() {
drawer.classList.remove("open");
if (headerBar) headerBar.style.zIndex = "";
if (header) header.style.zIndex = "";
if (overlay) overlay.classList.remove("active");
}

// Open drawer on click
openButton.addEventListener("click", openDrawer);

// Close drawer on close button click
closeButton.addEventListener("click", closeDrawer);

// Close drawer when clicking outside
document.addEventListener("click", function (event) {
if (
drawer.classList.contains("open") &&
!drawer.contains(event.target) &&
!openButton.contains(event.target)
) {
closeDrawer();
}
});
});
